const NO_OPTION_LABEL = '指定なし'
const BREAKDOWN_INDENT = '　' // 内訳の受領者行の字下げ（全角スペース1つ）

/**
 * キッチン伝票1枚分（プリンタ + 商品名）の受領者行と備考を組み立てる
 * サーバー側(yonarezi PrintTicketService.resolve_recipients_and_remark)と同じ規則に揃える
 *
 * - 中身(オプション)が1件も無ければ、受領者名を重複なしで並べるだけ（従来どおり）
 * - 中身があれば「中身 ×杯数」＋受領者(1人1行・重複なし)の内訳行にする。中身は備考に重ねて出さない
 * - slip-print は受領者行を1行ずつ出すだけなので、内訳行も recipientNames に入れる
 *
 * @param {Array<{names: string[], optionsText: string}>} orderEntries - 明細1件ごとの受領者名と中身
 * @param {string} [remark] - 商品の備考
 * @returns {{recipientNames: string[], itemRemark: (string|undefined)}}
 */
export function buildKitchenSlipLines(orderEntries, remark) {
  const itemRemark = remark || undefined

  if (orderEntries.every(e => !e.optionsText)) {
    return { recipientNames: [...new Set(orderEntries.flatMap(e => e.names))], itemRemark }
  }

  // Map は挿入順を保つので、中身・受領者とも注文に現れた順になる
  const byOption = new Map()
  orderEntries.forEach(e => {
    const label = e.optionsText || NO_OPTION_LABEL
    if (!byOption.has(label)) byOption.set(label, [])
    byOption.get(label).push(e)
  })

  const recipientNames = [...byOption].flatMap(([label, entries]) => {
    const names = [...new Set(entries.flatMap(e => e.names))]

    return [`${label} ×${entries.length}`, ...names.map(name => `${BREAKDOWN_INDENT}${name}`)]
  })

  return { recipientNames, itemRemark }
}
